import UserStatusToken from '@apps/truevail/admin/tokens/user_status'
import SupportAssignment from '@admin/components/support_assignment'
import Panel from '@admin/components/panel'
import UserToken from '@admin/tokens/user'
import React from 'react'
import New from './new'

const getSupportUsers = (advisor) => ({
  title: 't(Assign Support Users)',
  entity: 'user',
  format: (user) => <UserToken { ...user } />,
  compareKey: 'account_id',
  valueKey: 'account_ids',
  action: `/api/admin/truevail/admin/advisors/${advisor.id}/users/support_users`,
  assignedEndpoint: `/api/admin/truevail/admin/advisors/${advisor.id}/users/support_users`,
  unassignedEndpoint: `/api/admin/truevail/admin/advisors/${advisor.id}/users/support_users/all`
})

const mapPropsToPanel = (props, context) => ({
  title: 't(Users)',
  collection: {
    endpoint: `/api/admin/truevail/admin/advisors/${props.advisor.id}/users`,
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Name)', key: 'last_name', primary: true, format: (user) => (
        <UserToken { ...user } show_email={ true } show_type={ true } />
      ) },
      { label: 't(Activation)', key: 'account.activation_sent_at', primary: true, collapsing: true, format: UserStatusToken }
    ],
    defaultSort: { key: 'last_name', order: 'asc' },
    empty: {
      svg: 'user_round',
      title: 't(No Users)',
      text: 't(You have not yet created any users for this advisor)',
      buttons: [
        { 
          label: 'Add User', 
          modal: <New advisor={ props.advisor } /> 
        }
      ]
    },
    recordTasks: (record) => [
      {
        label: 't(Activate User)',
        svg: 'check',
        show: record.account.activated_at !== null && !record.is_active,
        request: {
          endpoint: `/api/admin/truevail/admin/advisors/${props.advisor.id}/users/${record.id}/enable`,
          method: 'PATCH',
          body: {
            is_active: true
          },
          onFailure: (result) => context.flash.set('error', 't(Unable to activate user)')
        }
      },
      {
        label: 't(Deactivate User)',
        svg: 'x',
        show: record.account.activated_at !== null && record.is_active,
        request: {
          endpoint: `/api/admin/truevail/admin/advisors/${props.advisor.id}/users/${record.id}/enable`,
          method: 'PATCH',
          body: {
            is_active: false
          },
          onFailure: (result) => context.flash.set('error', 't(Unable to deactivate user)')
        }
      },
      {
        label: 't(Unblock User)',
        svg: 'ban',
        show: record.is_blocked,
        request: {
          method: 'PATCH',
          endpoint: `/api/admin/truevail/admin/advisors/${props.advisor.id}/users/${record.id}/unblock`,
          onFailure: (reult) => context.flash.set('error', 't(Unable to unblock user)'),
          onSuccess: () => context.flash.set('success', 't(The user has been unblocked)')
        }
      },
      {
        label: 't(Send Password Reset)',
        svg: 'mail',
        show: record.account.activated_at !== null,
        request: {
          method: 'PATCH',
          endpoint: `/api/admin/truevail/admin/advisors/${props.advisor.id}/users/${record.id}/reset`,
          onFailure: () => context.flash.set('error', 't(Unable to send reset email)'),
          onSuccess: () => context.flash.set('success', 't(Email queued for delivery)')
        }
      },
      {
        label: 't(Send Activation Email)',
        svg: 'mail',
        show: record.account.activated_at === null,
        request: {
          method: 'PATCH',
          endpoint: `/api/admin/truevail/admin/advisors/${props.advisor.id}/users/${record.id}/activate`,
          onFailure: (result) => context.flash.set('error', 't(Unable to send activation email)'),
          onSuccess: (result) => context.flash.set('success', 't(Email queued for delivery)')
        }
      }
    ],
    entity: 'user'
  },
  tasks : {
    svg: 'settings2',
    items: [
      { 
        label: 'Add User', 
        svg: 'user_round',
        modal: <New advisor={ props.advisor } /> 
      },
      { 
        label: 't(Manage Support Users)',
        svg: 'life_buoy',
        modal: <SupportAssignment { ...getSupportUsers(props.advisor) } />
      }
    ]
  }
})

export default Panel(null, mapPropsToPanel)
